import type { DefaultOptionType } from 'antd/es/select';
import type { ShipmentLocationTypesResponse } from './api';

export const normalizeShipmentLocationTypes = (list: ShipmentLocationTypesResponse): DefaultOptionType[] => {
  if (!list) {
    return [];
  }
  return list.map((row) => ({
    label: row.codeDesc,
    value: row.codeId,
  }));
};
